module.exports = __webpack_public_path__ + "img/mianjianchanping-sp.8473ee70.png";